import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router';
import { logout } from '../../actions/auth';

const Logout: React.FC = () => {
  const dispatch = useDispatch();

  dispatch(logout());

  return <Redirect to="/login" />;
}

export default Logout;
